import { Component, OnInit, QueryList, ViewChildren } from '@angular/core'; 
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { Loading } from 'src/app/Class/Loading';
import { PqsAdminService } from 'src/app/servicios/pqs-admin.service';
import { UserService } from 'src/app/servicios/user.service';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-historial-pqrs',
  templateUrl: './historial-pqrs.component.html',
  styleUrls: ['./historial-pqrs.component.css']
})
export class HistorialPqrsComponent implements OnInit {

  public server = '';
  public historialSolicitudes: any = [];
  public detalles: any = { documentos:[], documentosRespuesta: [] };
  public dtTrigger: Subject<any> = new Subject();
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;

  public dtOptions: DataTables.Settings = DTConfig.dtConf;
  Toast = Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 3000 });

  constructor(private servi: PqsAdminService, public loading: Loading, private user:UserService) {
    
    this.getListado(false);

    this.server = servi.getServe();  
  }

  ngOnInit() {
  }

  getListado(render) {

    this.loading.estado = true;
    this.servi.getListadoHistorial()
    .subscribe(data => {

       this.historialSolicitudes = data['historialSolicitudes'].length > 0 ? data['historialSolicitudes'] : []

       if (render) {
          this.Toast.fire({ type: 'success', title: 'Listados actualizados exitosamente' });
          this.rerender();
        }
       this.dtTrigger.next();
       this.loading.estado = false;
      });
  }

  openModalDetalles(item) 
  { 
    this.loading.estado = true;

    this.servi.getDetalle(item.id)
    .subscribe(data => {
      this.detalles = data;
      $('#ModaldetalleSolicitud').modal('show');
      this.loading.estado = false;
    });
  }

  rerender(): void {
    this.dtElements.forEach((dtElement: DataTableDirective) => {
      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    });
  }


}
